import { ConciergeKnowledgeSchema } from "@redotech/redo-model/concierge-knowledge";
import * as z from "zod/v4";

export const updateConciergeKnowledge = {
  name: "updateConciergeKnowledge" as const,
  input: z.object({
    _id: z.string(),
    whenToUse: z.string().optional(),
    title: z.string().optional(),
    knowledge: z.string().optional(),
    enabled: z.boolean().optional(),
    expiresAt: z.date().nullish(),
    recommendedProductIds: z.array(z.string()).max(5).nullish(),
  }),
  output: ConciergeKnowledgeSchema,
};
